import React, { forwardRef, ButtonHTMLAttributes } from 'react'

import ActivityIndicator from './activity-indocator'

interface TButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant: 'contained' | 'text'
  color?: 'primary' | 'secondary' | 'error'
  disabledVarian?: 'loading' | 'disabled'
  fullWidth?: boolean
}

const Button = forwardRef<HTMLButtonElement, TButtonProps>(function Button(
  {
    variant,
    color = 'primary',
    children,
    disabledVarian = 'loading',
    fullWidth = true,
    ...buttonProps
  },
  ref,
) {
  const selectedColor = {
    primary: {
      bg: 'bg-pop-business-blue',
      border: 'border-pop-business-blue',
      text: 'text-pop-business-blue',
    },
    secondary: {
      bg: 'bg-pop-pumpkin-orange',
      border: 'border-pop-pumpkin-orange',
      text: 'text-pop-pumpkin-orange',
    },
    error: {
      bg: 'bg-pop-error',
      border: 'border-pop-error',
      text: 'text-pop-error',
    },
  }[color]

  const bgClass =
    variant === 'contained'
      ? `${selectedColor.bg}`
      : `bg-transparent border ${buttonProps.disabled ? 'border-pop-gray-4' : selectedColor.border}`
  const textClass =
    variant === 'contained'
      ? 'text-pop-background'
      : `${buttonProps.disabled ? 'text-pop-gray-4' : selectedColor.text}`
  const disabledVariantClass =
    buttonProps.disabled && disabledVarian === 'disabled' && variant === 'contained'
      ? 'bg-pop-gray-4 text-white'
      : ''
  const fullWidthClass = fullWidth ? 'w-full' : ''

  const buttonClasses = [
    'flex',
    'flex-row',
    'items-center',
    'gap-2',
    'justify-center',
    'px-4',
    'py-3',
    'font-medium',
    'rounded-full',
    'text-sm',
    fullWidthClass,
    bgClass,
    textClass,
    disabledVariantClass,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button ref={ref} className={buttonClasses} {...buttonProps}>
      {buttonProps.disabled && disabledVarian === 'loading' && <ActivityIndicator size='small' />}
      {children}
    </button>
  )
})

export default Button
